import React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import { Link as ScrollLink } from 'react-scroll';
import { FormattedMessage } from 'react-intl';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown } from '@fortawesome/free-solid-svg-icons';

import StarRating from 'Components/ProductReviews/UserReviews/StarRating';
import UserRatingsBreakdown from 'Components/ProductReviews/UserReviews/UserRatingsBreakdown';

import 'Components/ProductReviews/UserReviews/StarRatingToolTip.scss';

const StarRatingToolTip = ({
  userReviewSummary,
  type,
  slug,
}) => {
  const userReviewRatingScore = get(userReviewSummary, 'rating_score');
  const userReviewTotalRatings = get(userReviewSummary, 'total_ratings');
  const userReviewRatingScoreBreakdown = get(userReviewSummary, 'rating_score_breakdown', {});

  if (!userReviewRatingScore || userReviewRatingScore === 0) return false;

  return (
    <div className="star-rating-tooltip-container">
      <ScrollLink
        spy
        smooth
        activeClass="active"
        to="user-reviews"
        duration={500}
        className="star-rating-tooltip-link"
      >
        <StarRating rating={userReviewRatingScore} />
        <div className="chevron-container">
          <FontAwesomeIcon icon={faChevronDown} />
        </div>
        <div className="rating-text-link">
          <FormattedMessage
            id="star-rating-tool-tip.total-ratings"
            defaultMessage="{userReviewTotalRatings, plural, one {# User Rating} other {# User Ratings}}"
            values={{ userReviewTotalRatings }}
          />
        </div>
      </ScrollLink>

      <div className="tooltip-container">
        <div className="tooltip-arrow" />
        <div className="tooltip-main-body">
          <div className="heading-container">
            <div className="stars-text-container">
              <StarRating rating={userReviewRatingScore} />
              <div className="out-of-five">
                <FormattedMessage
                  id="star-rating-tool-tip.out-of-five"
                  defaultMessage="{userReviewRatingScore} out of 5"
                  values={{ userReviewRatingScore }}
                />
              </div>
            </div>
            <div className="tooltip-ratings-text">
              <FormattedMessage
                id="star-rating-tool-tip.total-ratings"
                defaultMessage="{userReviewTotalRatings, plural, one {# User Rating} other {# User Ratings}}"
                values={{ userReviewTotalRatings }}
              />
            </div>
          </div>
          <div className="tooltip-divider" />
          <UserRatingsBreakdown
            mobileLayout
            slug={slug}
            type={type}
            userReviewRatingScoreBreakdown={userReviewRatingScoreBreakdown}
          />
          <div className="tooltip-divider" />
          <div className="see-all-link-container">
            <ScrollLink
              spy
              smooth
              activeClass="active"
              to="user-reviews"
              duration={500}
              className="rating-text-link"
            >
              <FormattedMessage
                id="star-rating-tool-tip.body.all-reviews"
                defaultMessage="See all customer reviews"
              />
            </ScrollLink>
          </div>
        </div>
      </div>
    </div>
  );
};

StarRatingToolTip.propTypes = {
  userReviewSummary: PropTypes.shape(),
  type: PropTypes.string,
  slug: PropTypes.string,
};

StarRatingToolTip.defaultProps = {
  userReviewSummary: {},
  type: '',
  slug: '',
};

export default StarRatingToolTip;
